module.exports = __webpack_public_path__ + "media/images/v2/illustration_4-b5ddbe67b5d6c95f53ca6ea5d51d20a4.svg";